/**
 * The report title, derived from the description (ISS-485).
 *
 * The widget is one step with one big description box, so there is no
 * separate title field. The server still requires a title (it is what the
 * triage board and Chat cards show), so the title is the description's first
 * sentence: first non-blank line, cut at the first sentence end, capped.
 * An AI-written title is a separate, later change (ISS-485 ask #4).
 */

/** Longest derived title; the server allows 200. */
export const MAX_DERIVED_TITLE_LENGTH = 120;

export function deriveReportTitle(description: string): string {
  const firstLine = description.split(/\r?\n/).map((l) => l.trim()).find((l) => l.length > 0) ?? '';
  const sentence = firstLine.match(/^.*?[.!?](?=\s|$)/)?.[0] ?? firstLine;
  const title = sentence.trim();
  return title.length > MAX_DERIVED_TITLE_LENGTH
    ? `${title.slice(0, MAX_DERIVED_TITLE_LENGTH - 1).trimEnd()}…`
    : title;
}
